var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DefaultContentLayout",
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.requests, loading: _vm.$apollo.loading } },
        [
          _c("ActionPanel", {
            staticClass: "my-3",
            attrs: {
              total: _vm.paginationConfig.total,
              pageName: `Total Requests`,
            },
          }),
          _c(
            "div",
            [
              _c("CustomRequestFilters", {
                staticClass: "relative",
                attrs: {
                  currentUserId: _vm.currentUser.id,
                  isAdmin: _vm.isAdmin,
                },
                on: {
                  filtersChanged: _vm.updateFilters,
                  resetFilters: _vm.resetFilters,
                },
              }),
              !_vm.isAdmin
                ? _c("UiButtonMessage", {
                    attrs: {
                      label: "add gray",
                      buttonClass: "customAdd customPlacement",
                      buttonText: "External Sourcing Request",
                      textClass: "pl-2 text-base text-black-header",
                    },
                    on: { click: _vm.toggleRequestModal },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.showEmptyListPlaceholder
            ? _c("EmptyListPlaceholder", {
                attrs: { title: _vm.emptyListTitle },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageRequests")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2557147869
                ),
              })
            : _c("div", [
                _c(
                  "div",
                  { staticClass: "flex flex-wrap flex-row gap-4 mt-5" },
                  _vm._l(_vm.requests, function (request) {
                    return _c("RequestCardTalent", {
                      key: request.id,
                      attrs: {
                        request: request,
                        skills: request.skills,
                        createdBy: request.created_by,
                        currentUserId: _vm.currentUser.id,
                        isAdmin: _vm.isAdmin,
                        companyId: _vm.company.id,
                      },
                      on: { refetch: _vm.handleRefetch },
                    })
                  }),
                  1
                ),
              ]),
          _vm.isDataLoaded
            ? _c("CardPagination", {
                attrs: { config: _vm.paginationConfig },
                on: {
                  "update:config": function ($event) {
                    _vm.paginationConfig = $event
                  },
                },
              })
            : _vm._e(),
          _vm.dialog
            ? _c("CustomRequestModal", {
                attrs: {
                  currentUserId: _vm.currentUser.id,
                  companyId: _vm.company.id,
                  isAdmin: _vm.isAdmin,
                },
                on: {
                  close: _vm.toggleRequestModal,
                  refetch: _vm.handleRefetch,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }